
import { defineComponent, onMounted, ref } from "vue";
import { ErrorMessage, Field, Form } from "vee-validate";
import { Actions, Menu, Mutations, Users } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import * as Yup from "yup";
import { formatUserMenu } from "@/utils/userMenuUtil";
import { CookieComponent } from "@/assets/ts/components";
import ApiService from "@/core/services/ApiService";

export default defineComponent({
  name: "sign-in",
  components: {
    Field,
    Form,
    ErrorMessage,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const disabled = ref<boolean>(false);
    const isLoading = ref(false)

    const submitButton = ref<HTMLElement | null>(null);

    //Create form validation object
    const login = Yup.object().shape({
      userName: Yup.string().required().label("userName"),
      password: Yup.string().required().label("password"),
    });

    //Form submit function
    const onSubmitLogin = (values) => {
      // Clear existing errors
      store.dispatch(Actions.PURGE);
      if (submitButton.value) {
        // Activate indicator
        submitButton.value.setAttribute("data-kt-indicator", "on");
        disabled.value = true;
        isLoading.value = true;
      }

      store
        .dispatch(Actions.LOGIN, {...values, currentSystem:parseInt(CookieComponent.get("system") as string)})
        .then(async (res) => {
          if (res.code == 200) {
            store.commit('menuRouteLoaded', false);
            if (res.data.nMaNhomQuyen != 1) {
              store.dispatch(Menu.findNavTree,parseInt(CookieComponent.get("system") as string)).then(async (res1) => {
                if (res1.code == 200) {
                  const data = res1.data;
                  await localStorage.removeItem("MainMenuConfig");
                  localStorage.setItem(
                    "MainMenuConfig",
                    JSON.stringify(
                      formatUserMenu(data, res.data.userTypeId)
                    )
                  );

                  if(res.data.nMaNhomQuyen == 8)
                    router.push({ name: "teller" });
                  else if(res.data.nMaNhomQuyen == 11)
                    router.push({ name: "boothCount" });
                  else
                    router.push({ name: "dashboard" });
                }
              });

            } else {
              router.push("dashboard");
            }
          } else {
            Swal.fire({
              text: res.msg,
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Thử lại!",
              customClass: {
                confirmButton: "btn fw-bold btn-light-danger",
              },
            }).then(function () {
              disabled.value = false;
              isLoading.value = false
            });
          }
        })
        .catch(() => {
          Swal.fire({
            text: store.getters.getErrors[0],
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Thử lại!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-danger",
            },
          }).then(function () {
              disabled.value = false;
              isLoading.value = false
            });;
        });

        /* onMounted(() =>{
          store.dispatch(Mutations.PURGE_AUTH)
          ApiService.clearHeader()
        }) */
      //Deactivate indicator
      submitButton.value?.removeAttribute("data-kt-indicator");
    };
    return {
      onSubmitLogin,
      login,
      submitButton,
      disabled,
      isLoading
    };
  },
  mounted(){
    ApiService.clearHeader()
  }
});
